import '.a{display:grid;}.ssr-plugin'
import '.ie{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { BlogCard } from '../../card/BlogCard'
import { pages } from '@app/util/links'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { styled } from 'inlines'
import { StoredImage } from '@app/types/StoredImage'

export type StoriesContentSectionType = {
  type: 'stories'
  title: string
  items: {
    id: number
    slug: string
    title: string
    intro?: string
    images?: StoredImage[]
  }[]
}

export const StoriesContentSection = ({
  title,
  items,
}: StoriesContentSectionType) => {
  const t = useTranslations().app.blogPage

  if (items.length === 0) return null

  return (
    <Column gap="0.5rem">
      <Title.H2>{title}</Title.H2>
      <styled.div className="a ie g"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
          },
          '@media (max-width: 800px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {items.slice(0, 3).map((item) => (
          <BlogCard
            key={item.id}
            title={item.title}
            meta={t.tabs['stories']}
            image={item.images?.[0]}
            intro={item.intro}
            to={pages.blog('verhalen', item.slug)}
          />
        ))}
      </styled.div>
    </Column>
  )
}
